import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutocompleteComponent } from './autocomplete.component';
import { WmInputModule } from '../input/index';
import { WmTransitionModule } from '../transition/index';
import { WmCardModule } from '../card/index';

@NgModule({
	declarations: [AutocompleteComponent],
	imports: [CommonModule, WmInputModule, WmTransitionModule, WmCardModule],
	exports: [AutocompleteComponent]
})
export class WmAutocompleteModule {}
